import React, { useState } from 'react';
import Sections from '../../../../components/Sections';
import { ExtensionContent } from '../../../../utils/content';

export default function Extension() {
    const [readMore, setReadMore]=useState(false);
  return (<div className=' border rounded-md'>
  {!readMore &&(<div className="bg-white">
  <div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
    <div className="mx-auto max-w-2xl text-center">
      <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
      Boost Your Onboarding Experience!
        <br />
        Welcome to Milir Onboarding.
      </h2>
      <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-600">
      {ExtensionContent.description}
      </p>
      <div className="mt-10 flex items-center justify-center gap-x-6">
        <a
          href="#"
          className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Get started
        </a>
        <div onClick={()=>{
          setReadMore(true);
        }} className="cursor-pointer text-sm font-semibold leading-6 text-gray-900">
          Learn more <span aria-hidden="true">→</span>
        </div>
      </div>
    </div>
  </div>
</div>)}
{readMore &&(<Sections sectionList={ExtensionContent.sectionList} descList={ExtensionContent.descList} title={ExtensionContent.sectionTitle} back={setReadMore}/>)}
  </div>
)
}
